import React from 'react'
import smartcitizen from '../img/smartcitizen.jpg'

export const About = () => {
    return (
        <div>
            <div className="row">
                <div className="col-sm-12">
                    <h1>About Smart Citizen Kit</h1>
                    <img src={smartcitizen} className="img-responsive" alt="SmartCitizen Kit" />
                </div>
            </div>

            <div className="row">
                <div className="col-md-8 col-md-offset-2 col-sm-12">
                    <h2 className="inside">My personal experience with the board</h2>
                    <p>The Smart Citizen Kit is an Arduino based sensor kit which basically provides you with 6 sensors: temperature, humidity, noise, light, CO and NO2.</p>
                    <p>The initially setup took some headache. Also the USB connection broke from the board. Since this was a known issue Smart Citizen replaced the item kindly. I got the whole system running in september 2014. However it stopped functioning correctly shortly after. I tried a couple of times to re-activate the thing but to no success. After the struggle with the initially setup I gave up on it. A shame after having spent $200.</p>
                    <p>Somehow I came back to it in early 2017. I noticed my own WiFi settings were wrong, and after correcting the board connected smoothly to the internet. My fault obviously. The kit is running for months now and I decided to write an app since I started learning ReactJS</p>
                    <h2 className="inside">Links</h2>
                    <ul>
                        <li><a href="https://smartcitizen.me/" target="_blank" rel="noopener noreferrer">Smart Citizen website</a></li>
                        <li><a href="https://www.kickstarter.com/projects/acrobotic/the-smart-citizen-kit-crowdsourced-environmental-m" target="_blank" rel="noopener noreferrer">Smart Citizen Kickstarter page</a></li>
                        <li><a href="http://waag.org/en/project/smart-citizen-kit" target="_blank" rel="noopener noreferrer">Smart Citizen project at Waag Society Netherlands</a></li>
                    </ul>
                </div>
            </div>

        </div>

    )
}


// WEBPACK FOOTER //
// ./src/components/About.js